<template>
  <div>
<!--    <div v-if="settings.theme.input.sublabel"  class="text-body2 mw-form-v2-label" v-html="field.label"></div>-->
    <q-field
        borderless
        v-model="fieldValue"
        :rules="field.required ? [ val => val && val.length > 0 || requiredText] : []"
        hide-bottom-space
    >
      <template v-slot:control>
    <q-option-group
        :options="optionsForSelect"
        type="checkbox"
        v-model="fieldValue"
        debounce="500"
    />
      </template>
    </q-field>
<!--    <div class="text-caption" v-html="field.description"></div>-->
  </div>


</template>

<script>
import {mapFields} from "vuex-map-fields";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
      value: null
    };
  },
  emits: ['update:modelValue'],
  methods: {

  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
     return this.field.required_text ? this.field.required_text : 'Please select something';
    },
    optionsForSelect: function () {
      let data = [];
      for (const [key, value] of Object.entries(this.field.options)) {
        data.push( {
          label: value,
          value: key
        });
      }
      return data;
    },
    fieldValue: {
      get() {
        return this.modelValue ? this.modelValue : []
      },
      set(value) {
        //console.log(value);
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
